import { ArrowRightIcon } from '@phosphor-icons/react'
import React, { FC } from 'react'
import { AppButton, AppImage, AppText, AppTitle } from '@/shared/ui'
import { Container, descriptionStyle, titleStyle } from './CardSuccess.styles'
import { buttonStyle } from '../ChangePasswordInputs/ChangePasswordInputs.styles'
import { useTranslation } from 'react-i18next'

interface CardSuccessProps {
  onContinue: () => void
}

const CardSuccess: FC<CardSuccessProps> = ({ onContinue }) => {
  const { t } = useTranslation()
  return (
    <Container>
      <AppImage
        preview={false}
        src='https://odin-images-and-files-production.s3.us-east-1.amazonaws.com/shield_success.svg'
      />
      <AppTitle level={4} style={titleStyle}>
        {t('success_change_password')}
      </AppTitle>
      <AppText style={descriptionStyle}>{t('thank_helping_platform_safe')}</AppText>
      <AppButton fullWidth icon={<ArrowRightIcon />} style={buttonStyle} onClick={onContinue}>
        {t('continue')}
      </AppButton>
    </Container>
  )
}

export default CardSuccess
